import React  from "react";
import { Link } from "react-router-dom";

class Nav extends React.Component {
  render() {
    return (
      <div id="nav">
          <Link to="/">Home</Link>
          <Link to="/Profile">Profile</Link>
          <Link to="/Works">Works</Link>
          <Link to="/Contact">Contact</Link>
      </div>
    );
  }
}

export default Nav;
